import React from "react";
import SEO from "../components/SEO";

const NotFound = () => {
  return (
    <main style={{ padding: "80px 20px", textAlign: "center" }}>
      <SEO
        title="404 - Page Not Found"
        description="The page you are looking for does not exist."
        url="https://satimatechnova.co.ke/404"
      />

      <h1>404</h1>
      <p>The page you are looking for could not be found.</p>
    </main>
  );
};

export default NotFound;
